import React, { forwardRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { useIsEdited } from "../../Providers/IsEditedProvider";


const DropdownElement = forwardRef(({ disabled, options, value, onChange, optionLabel, placeholder, className, props }, ref) => {

    const valueTemplate = (option) => {
        return (
            <div
                style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    maxWidth: '100%',
                }}
            >
                {option ? option[optionLabel] : '-- Please Select --'}
            </div>
        );
    };
    const { setIsEdited } = useIsEdited();

    return (
        <div className="flex">
            <Dropdown
                value={value}
                onChange={(e) => {
                    setIsEdited(true);
                    onChange(e);
                }}
                options={[{ [optionLabel]: '-- Please select --', value: null }, ...options]}
                optionLabel={optionLabel}
                placeholder={placeholder}
                filter
                className={className || 'w-full md:w-14rem'}
                disabled={disabled}
                ref={ref}
                title={value != undefined ? value[optionLabel] : ''}
                valueTemplate={valueTemplate}
            />
        </div>
    );
});

export default DropdownElement;
